
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5JjoD", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $52992e244d1337e7$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Portuguese (Brazil)
var $52992e244d1337e7$export$2e2bcd8739ae039 = {
    'navigation.global-shortcuts.all-sites': 'Todos os sites',
    'navigation.global-shortcuts.menu-expand-item.close-button-aria-label': 'Fechar',
    'navigation.global-shortcuts.menu-link-item.disabled-item-aria-label': "(indispon\xedvel no momento)",
    'navigation.global-shortcuts.sites': 'Sites de {productName}'
};

});


//# sourceMappingURL=pt_BR.88e63e50.js.map
